import script from "./BlockList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlockList.vue?vue&type=script&lang=ts&setup=true"

import "./BlockList.vue?vue&type=style&index=0&id=cb465586&lang=sass"

const __exports__ = script;

export default __exports__